import Api from '../services/Api';
import { Response } from './Types';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';

class CaixaLancamentoController {
  public static async Listar(values: any): Promise<Response> {
    try {    
      const response = await Api.post(`api/CaixaLancamento/Listar`, values);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default CaixaLancamentoController